
import Body from './body'
import BottomContext from './bottom'
const TempleteFive = () => {
    return <>
        <Body></Body>
        <BottomContext></BottomContext>
    </>
}

export default TempleteFive